import { Button } from 'design-system';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import './Paginator.css';

const Paginator = (props) => {
  const handlePrevClick = () => {
    props.setCurrentPage(props.currentPage - 1);
  };

  const handleNextClick = () => {
    props.setCurrentPage(props.currentPage + 1);
  };

  return (
    <div className="paginator">
      <Button
        onClick={handlePrevClick}
        disabled={props.currentPage === 1}
        shape="round"
        size="small"
        icon={<ChevronLeft size={16} />}
      >
        <FormattedMessage id="pagination.prev" />
      </Button>
      <Button
        onClick={handleNextClick}
        disabled={props.currentPage >= props.totalPages}
        shape="round"
        size="small"
        rightIcon={<ChevronRight size={16} />}
      >
        <FormattedMessage id="pagination.next" />
      </Button>
    </div>
  );
};

export default Paginator;
